import {NgModule} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";

import {NavbarVerticalStyle2Component} from './style-2.component';
import {CdkNavigationComponent} from '@cdk/components/navigation/navigation.component';

@NgModule({
    imports: [
        MatButtonModule,
        MatIconModule,
        CdkNavigationComponent,
        NavbarVerticalStyle2Component
    ],
    exports: [
        NavbarVerticalStyle2Component
    ]
})
export class NavbarVerticalStyle2Module {
}
